<template>
   <div class="card">
       <div v-if="showEditButton" class="card-header">
           <button type="button" v-if="!userEdit" class="btn btn-primary" @click="userEdit = true">Edit</button>
           <button type="button" v-else class="btn btn-primary" @click="userEdit = false">Close</button>
       </div>
       <div class="card-body">
           <div v-if="userEdit" id="editor">
               <froala
                       name="description"
                       ref="editor"
                       tag="textarea" :config="froalaConfig" v-model="tempDescription"></froala>
           </div>
           <div v-else>
               <froalaView v-model="tempDescription"></froalaView>
           </div>
       </div>
   </div>
</template>

<script>
    export default {
        name: "task-description",

        props: {
            description: String,
            create: Boolean
        },
        data() {
            return {
                tempDescription: this.description,
                userEdit: this.create,
                showEditButton: !this.create,
                froalaConfig: {
                    charCounterCount: false,
                    placeholderText: this.create ? 'Create description' : 'Edit description'
                }
            }
        }
    }
</script>

<style scoped>
    #editor > div > div.fr-wrapper > div:nth-child(1) {
        visibility: hidden;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/tasks/TaskDescription.vue